import React from 'react';
import SettingsLayout from '@/components/settings/SettingsLayout';
import SettingsOrganization from '@/components/settings/SettingsOrganization';

export default function ImpostazioniStruttura() {
  return (
    <SettingsLayout
      eyebrow="Impostazioni · Azienda"
      title="Struttura aziendale"
      description="Gestisci aziende, locali e reparti in un’unica struttura organizzata."
      breadcrumbs={[{ label: 'Impostazioni', to: '/impostazioni' }]}
      current="Struttura aziendale"
      navigation={[
        { to: '/impostazioni/ferie-fabbisogno', label: 'Fabbisogno minimo ferie' },
      ]}
      testId="impostazioni-struttura-page"
    >
      <SettingsOrganization testId="struttura-aziendale" />
    </SettingsLayout>
  );
}